import Plan from '@/common/models/plan/Plan';
import BudgetBreakdownService from '@/org-app/components/plans/budgetBreakdown/BudgetBreakdownService';
import rootState from '@/store/state';

type TSharedPlanBudgetBreakdown = Pick<
  BudgetBreakdownService,
  | 'name'
  | 'eCPM'
  | 'screenCount'
  | 'siteCount'
  | 'networkCount'
  | 'budget'
  | 'impressions'
  | 'audienceConcentration'
  | 'estimatedBudget'
  | 'estimatedImpressions'
  | 'impressionCapacity'
  | 'isSupplySharedPlan'
  | 'isStroeerSharedPlan'
  | 'targetingName'
>;

export default class BudgetBreakdownData {
  public static deserialize(sharedPlanBudgetBreakdown: string, plan: Plan): BudgetBreakdownService[] {
    if (sharedPlanBudgetBreakdown == null) {
      return null;
    }
    const budgetBreakdown = JSON.parse(sharedPlanBudgetBreakdown);

    const breakdownsItems = budgetBreakdown.map((x) => {
      const breakdown = new BudgetBreakdownService('data-budget-breakdown');
      breakdown.name = x.name;
      breakdown.budget = x.budget;
      breakdown.impressions = x.impressions;
      breakdown.eCPM = x.eCPM;
      breakdown.screenCount = x.screenCount;
      breakdown.siteCount = x.siteCount;
      breakdown.isSharedPlan = true;
      breakdown.estimatedBudget = x.estimatedBudget;
      breakdown.estimatedImpressions = x.estimatedImpressions;
      breakdown.networkCount = x.networkCount;
      breakdown.impressionCapacity = x.impressionCapacity;
      breakdown.audienceConcentration = x.audienceConcentration;
      breakdown.isSupplySharedPlan = x.isSupplySharedPlan;
      breakdown.isStroeerSharedPlan = x.isStroeerSharedPlan;
      breakdown.plan = plan;
      breakdown.targetingName = x.targetingName;
      return breakdown;
    });

    return breakdownsItems;
  }

  public static serialize(budgetBreakdown: BudgetBreakdownService[]): string {
    if (budgetBreakdown == null) {
      return null;
    }

    const sharedPlanBudgetBreakdown = budgetBreakdown.map((x) => {
      const breakdown = {} as TSharedPlanBudgetBreakdown;
      breakdown.name = x.name;
      breakdown.eCPM = x.eCPM;
      breakdown.screenCount = x.screenCount;
      breakdown.budget = x.budget;
      breakdown.impressions = x.impressions;
      breakdown.estimatedBudget = x.estimatedBudget;
      breakdown.estimatedImpressions = x.estimatedImpressions;
      breakdown.audienceConcentration = x.audienceConcentration;
      breakdown.targetingName = x.targetingName;

      if (rootState?.orgApp?.organization?.isSupplyOrganization) {
        breakdown.siteCount = x.siteCount;
        breakdown.isSupplySharedPlan = true;

        if (rootState?.orgApp?.organization?.isStroeerOrganization) {
          breakdown.isStroeerSharedPlan = true;
          breakdown.networkCount = x.networkCount;
          breakdown.impressionCapacity = x.impressionCapacity;
        }
      }
      return breakdown;
    });
    return JSON.stringify(sharedPlanBudgetBreakdown);
  }
}
